// extracted by mini-css-extract-plugin
module.exports = {"root":"MatchScores_root__zc4Da","scrollbar":"MatchScores_scrollbar__3fCif","mobileView":"MatchScores_mobileView__SpmbH","segments":"MatchScores_segments__abm_h"};